export const PROGRESS = {
    ACTIVE: 'ACTIVE',
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE'
};
